import {configureStore} from '@reduxjs/toolkit';
import {persistStore} from 'redux-persist';
import rootReducer from './rootReducer';
import {emptyApi as api} from './generated/api';

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    'persist/PERSIST',
                    'persist/REHYDRATE',
                    'persist/REGISTER',
                    'persist/PURGE',
                    'persist/FLUSH',
                    'persist/PAUSE',
                ],
                ignoredPaths: ['api'],
            },
            immutableCheck: true,
            thunk: true,
        }).concat(api.middleware),
    devTools: import.meta.env.MODE !== 'production',
    preloadedState: undefined,
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;